<template>
    <div @click='link' class="commenlink">
        <basis v-if="this.page=='basislist'" :list= 'li'></basis>
        <card  v-if="this.page=='cardlist'"  :cards= 'li'></card>
        <tab  v-if="this.page=='tablist'"  :tab= 'li'></tab>
        <banner  v-if="this.page=='swiper'"  :swipe= 'li'></banner>
    </div>
</template>
<script>
import basis from './basis'
import card from './card'
import tab from './tab'
import banner from './banner'
export default {
     data() {
      return {
        li:null,
        linkto:''
      }
    },
    props: ['item','page'],
    components:{
        basis,
        card,
        tab,
        banner
    },
    methods:{
      link(){
          if(this.linkto){
            this.$router.push({path: this.linkto,query:{id:this.li.LinkId,title:this.li.Title}});
          }
      }
    },
    watch:{
      item:{
        handler(newName, oldName) {
          this.li=newName
          if(newName.LinkType == 0 && newName.LinkId !=0){
              this.linkto ='detail'
          }else if(newName.LinkType == 1  && newName.LinkId !=0){
              this.linkto ='article'
          }else if(newName.LinkType == 2  && newName.LinkId !=0){
              this.linkto ='basisExperience'
          }
        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>
.commenlink{
    height: 100%;
}
</style>







// WEBPACK FOOTER //
// src/components/commonLink.vue